import { css } from "@emotion/react";
import { FC, ReactNode } from "react";

import {
  Button,
  DesignToken,
  Icon,
  IconSource,
  RadiusToken,
  SpacingToken,
  Text,
  Tooltip,
} from "@livechat/design-system-react-components";

import Flex from "components/layout/Flex";
import { withVar } from "themes/helpers";

interface IProps {
  icon: IconSource;
  title: string;
  status: ReactNode;
  onImportClick: () => void;
  disabled?: boolean;
  disableReason?: string;
  loading?: boolean;
  hideButton?: boolean;
}

export const ImportItem: FC<IProps> = ({
  icon,
  title,
  status,
  onImportClick,
  disabled = false,
  disableReason,
  loading = false,
  hideButton = false,
}) => {
  const ImportButton = (
    <Button kind="secondary" disabled={disabled} loading={loading} onClick={onImportClick}>
      Import
    </Button>
  );

  return (
    <Flex
      gap={withVar(SpacingToken.Spacing4)}
      alignItems="center"
      width="100%"
      padding={withVar(SpacingToken.Spacing4)}
      boxSizing="border-box"
      borderRadius={withVar(RadiusToken.Radius3)}
      border={`1px solid ${withVar(DesignToken.BorderBasicSecondary)}`}
      data-testid="import-item"
    >
      <Icon source={icon} size="xlarge" />
      <Flex column marginRight="auto" gap="4px">
        <Text bold>{title}</Text>
        <Flex gap="4px" alignItems="center">
          {status}
        </Flex>
      </Flex>
      {!hideButton && (
        <>
          {disabled && disableReason ? (
            <Tooltip
              css={css`
                max-width: 230px;
              `}
              triggerRenderer={ImportButton}
              placement="top-start"
              kind="invert"
            >
              {disableReason}
            </Tooltip>
          ) : (
            ImportButton
          )}
        </>
      )}
    </Flex>
  );
};
